import axios from "axios";
import { BASE_URL } from "./constants/base_url";
import Cookies from "js-cookie";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = Cookies.get("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Seçilmiş dil — backend gələcəkdə cavabı dilə görə formalaşdıra bilsin.
    // localStorage-dan birbaşa oxunur ki, i18n ↔ api dairəvi importu yaranmasın.
    const lang = localStorage.getItem("quizzo_lang");
    if (lang) {
      config.headers["Accept-Language"] = lang;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Token etibarsızdırsa (silinib/vaxtı bitib) — çıxış vəziyyətinə qaytar
    if (error.response?.status === 401 && Cookies.get("auth_token")) {
      Cookies.remove("auth_token");
      Cookies.remove("customer_name");
    }
    return Promise.reject(error);
  }
);

export default api;
